import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import { getDisplayName } from "./../utils/auth";

function Dashboard() {
  const navigate = useNavigate();

  const username = getDisplayName();
  const role = localStorage.getItem("role");

  const [data, setData] = useState({
    foods: [],
    visitors: [],
    vehicles: [],
    policies: [],
    hiredTransport: [],
    companyTransport: [],
    agreements: [],
    security: [],
    csr: [],
    dutyReports: [],
    repairs: [],
    accidents: [],
    transportCommittee: [],
  });

  useEffect(() => {
    fetchDashboardData();

    const interval = setInterval(() => {
      fetchDashboardData();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [
        foodsRes,
        visitorsRes,
        vehiclesRes,
        policiesRes,
        hiredRes,
        companyRes,
        agreementsRes,
        securityRes,
        csrRes,
        dutyRes,
        repairRes,
        accidentRes,
        transportCommitteeRes,
      ] = await Promise.all([
        axios.get("https://hrpsc.swisstekaluminium.com/api/foods"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/visitors"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/vehicles"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/policies"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/transport/hired"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/transport/company"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/agreements"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/security"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/csr"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/cleaning/duty"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/cleaning/repair"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/accidents"),
        axios.get("https://hrpsc.swisstekaluminium.com/api/transportcommittee"),
      ]);

      setData({
        foods: Array.isArray(foodsRes.data) ? foodsRes.data : [],
        visitors: Array.isArray(visitorsRes.data) ? visitorsRes.data : [],
        vehicles: Array.isArray(vehiclesRes.data) ? vehiclesRes.data : [],
        policies: Array.isArray(policiesRes.data) ? policiesRes.data : [],
        hiredTransport: Array.isArray(hiredRes.data) ? hiredRes.data : [],
        companyTransport: Array.isArray(companyRes.data) ? companyRes.data : [],
        agreements: Array.isArray(agreementsRes.data) ? agreementsRes.data : [],
        security: Array.isArray(securityRes.data) ? securityRes.data : [],
        csr: Array.isArray(csrRes.data) ? csrRes.data : [],
        dutyReports: Array.isArray(dutyRes.data) ? dutyRes.data : [],
        repairs: Array.isArray(repairRes.data) ? repairRes.data : [],
        accidents: Array.isArray(accidentRes.data) ? accidentRes.data : [],
        transportCommittee: Array.isArray(transportCommitteeRes.data)
          ? transportCommitteeRes.data
          : [],
      });
    } catch (error) {
      console.log("Dashboard Data Error:", error);
    }
  };

  const logout = () => {
  localStorage.clear();
  window.location.href = "/";
};

  const countByStatus = (array, status) => {
    return array.filter((item) => item.status === status).length;
  };

  const contractorsCount = data.visitors.filter(
    (item) => item.sector === "Contractors"
  ).length;

  const suppliersCount = data.visitors.filter(
    (item) => item.sector === "Suppliers"
  ).length;

  const interviewersCount = data.visitors.filter(
    (item) => item.sector === "Interviewers"
  ).length;

  const buyersCount = data.visitors.filter(
    (item) => item.sector === "Buyers"
  ).length;

  const companyVehicleCount = data.vehicles.filter(
    (item) =>
      item.companyStatus === "Company" ||
      item.vehicleOwner === "Company" ||
      item.vehicleCategory === "Company" ||
      item.category === "Company"
  ).length;

  const outsideVehicleCount =
    data.vehicles.length - companyVehicleCount;

  const cleaningYearCost = data.dutyReports.reduce(
    (total, item) => total + Number(item.totalCost || 0),
    0
  );
    return (
    <div>
      <div className="dashboard-header">
        <div>
          <h1>Welcome {username}</h1>
          <p>Role: {role}</p>
        </div>

        <button className="logout-btn" onClick={logout}>
          Logout
        </button>
      </div>

      <h2 className="dashboard-section-title">Food Committee</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total Requests</h3>
          <h1>{data.foods.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Completed</h3>
          <h1>{countByStatus(data.foods, "Completed")}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Pending</h3>
          <h1>{countByStatus(data.foods, "Pending")}</h1>
        </div>
      </div>

      <h2 className="dashboard-section-title">Visitors</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total Visitors</h3>
          <h1>{data.visitors.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Contractors</h3>
          <h1>{contractorsCount}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Suppliers</h3>
          <h1>{suppliersCount}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Interviewers</h3>
          <h1>{interviewersCount}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Buyers</h3>
          <h1>{buyersCount}</h1>
        </div>
      </div>

      <h2 className="dashboard-section-title">Vehicle Management</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total Vehicles</h3>
          <h1>{data.vehicles.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Company Vehicles</h3>
          <h1>{companyVehicleCount}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Outside Vehicles</h3>
          <h1>{outsideVehicleCount}</h1>
        </div>
      </div>

      <h2 className="dashboard-section-title">Policy Matters</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total Policies</h3>
          <h1>{data.policies.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Completed</h3>
          <h1>{countByStatus(data.policies, "Completed")}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Pending</h3>
          <h1>{countByStatus(data.policies, "Pending")}</h1>
        </div>
      </div>

      <h2 className="dashboard-section-title">Transportation</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Hired Transport</h3>
          <h1>{data.hiredTransport.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Company Vehicles</h3>
          <h1>{data.companyTransport.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Total Transport</h3>
          <h1>{data.hiredTransport.length + data.companyTransport.length}</h1>
        </div>
      </div>
            <h2 className="dashboard-section-title">Agreements / Insurance</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total Agreements</h3>
          <h1>{data.agreements.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Renewed</h3>
          <h1>{countByStatus(data.agreements, "Renewed")}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Pending</h3>
          <h1>{countByStatus(data.agreements, "Pending")}</h1>
        </div>
      </div>

      <h2 className="dashboard-section-title">Security</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total Security Reports</h3>
          <h1>{data.security.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Day Shift</h3>
          <h1>
            {data.security.filter((item) => item.shift === "Day").length}
          </h1>
        </div>

        <div className="dashboard-card">
          <h3>Night Shift</h3>
          <h1>
            {data.security.filter((item) => item.shift === "Night").length}
          </h1>
        </div>
      </div>

      <h2 className="dashboard-section-title">CSR</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total CSR Projects</h3>
          <h1>{data.csr.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Total Beneficiaries</h3>
          <h1>
            {data.csr.reduce(
              (total, item) => total + Number(item.beneficiaries || 0),
              0
            )}
          </h1>
        </div>

        <div className="dashboard-card">
          <h3>Total Cost</h3>
          <h1>
            Rs.
            {data.csr.reduce(
              (total, item) => total + Number(item.totalCost || 0),
              0
            )}
          </h1>
        </div>
      </div>

      <h2 className="dashboard-section-title">Cleaning & Repairs</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total Duty Reports</h3>
          <h1>{data.dutyReports.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Total Repairs</h3>
          <h1>{data.repairs.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Year Cost</h3>
          <h1>Rs.{cleaningYearCost}</h1>
        </div>
      </div>

      <h2 className="dashboard-section-title">Accident Records</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total Accidents</h3>
          <h1>{data.accidents.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Company Related</h3>
          <h1>
            {
              data.accidents.filter(
                (item) => item.companyStatus === "Company"
              ).length
            }
          </h1>
        </div>

        <div className="dashboard-card">
          <h3>External</h3>
          <h1>
            {
              data.accidents.filter(
                (item) => item.companyStatus === "Non Company"
              ).length
            }
          </h1>
        </div>
      </div>

      <h2 className="dashboard-section-title">Transport Committee</h2>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Total Requests</h3>
          <h1>{data.transportCommittee.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Pending</h3>
          <h1>{countByStatus(data.transportCommittee, "Pending")}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Solved</h3>
          <h1>{countByStatus(data.transportCommittee, "Solved")}</h1>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;